/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */

import React, { useEffect, useState } from "react";
import { Alert } from "@mui/material";
import PhoneInput, { isPossiblePhoneNumber } from "react-phone-number-input";
import 'react-phone-number-input/style.css'
import "react-toastify/dist/ReactToastify.css";
import "./Contact.css";
import { Slide, ToastContainer, toast } from "react-toastify";
const Contact = () => {
    const [loading, setLoading] = useState(false);
    const [formData, setData] = useState({
        name: "",
        mobile: "",
        email: "",
        message: "",
    });
    const [formError, setFormError] = useState(false);
    const [formErrorMessage, setformErrorMessage] = useState("All fields are mandatory.");
    const [errorState, setErrorState] = useState({
        errMsg: "",
        severity: "error",
    });

    const onFieldChange = (e) => {
        setFormError(false);
        if (e) {
            setData({ ...formData, [e.target.name]: e.target.value });
        }
    };
    const onMobileChange = (value) => {
        setFormError(false);
        if (value) {
            setData({ ...formData, mobile: value });
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        // Email validation using a regular expression
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        const isEmailValid = emailRegex.test(formData.email);
        const isMobileValid = isPossiblePhoneNumber(formData.mobile) ? true : false;
        if (formData.name && formData.email && formData.message && formData.mobile && isEmailValid && isMobileValid) {
            // await fetch(`https://eascustomerdashboardbackend-new-twxnie6xwq-km.a.run.app/api/user/contact-us`, {
            await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/contact-us`, {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                },
                body: JSON.stringify(formData),
            }).then((res) => {
                setLoading(false);
                if (res.status === 200) {
                    toast.success("Thank you for contacting EA&S.", { transition: Slide });
                    setData({ name: "", mobile: "", message: "", email: "" });
                } else {
                    toast.error("Something went wrong. Please try again", { transition: Slide });
                }
            });
        } else {
            setLoading(false);
            setFormError(true);
            setformErrorMessage("All fields are mandatory.");
        }
        // Display an error message if the email is not valid
        if (formData.name && formData.email && formData.message && formData.mobile && !isEmailValid) {
            setLoading(false);
            setFormError(true);
            setformErrorMessage("Please enter a valid email address");
        } else if (formData.name && formData.email && formData.message && formData.mobile && !isMobileValid) {
            setLoading(false);
            setFormError(true);
            setformErrorMessage("Please enter a valid mobile number");
        }
    };

    return (
        <>
            <div>
                {errorState.errMsg && (
                    <Alert
                        onClose={() => {
                            setErrorState({
                                ...errorState,
                                errMsg: "",
                            });
                        }}
                        severity={errorState.severity}
                    >
                        {errorState.errMsg}
                    </Alert>
                )}
            </div>
            <section className="mt-4 mb-4">
                <div className="container">
                    <div className="row">
                        <h1 className="text-center" style={{ color: "#2e3192" }}>
                            CONTACT US
                        </h1>
                        <div className="col-sm-6 mt-4">
                            <div className="text-center">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3314.6122863825876!2d151.19193731744386!3d-33.82231720000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12aeddc75b0127%3A0x915cb8b559e706d2!2sThe%20Forum%2C%201%20Sergeants%20Ln%2C%20St%20Leonards%20NSW%202065%2C%20Australia!5e0!3m2!1sen!2sin!4v1672860156067!5m2!1sen!2sin"
                                    width="100%"
                                    height="400"
                                    style={{ border: "0" }}
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="map"
                                />
                            </div>
                        </div>
                        <div className="col-sm-6 mt-4">
                            <form action="">
                                <input
                                    name="name"
                                    className="form-control mb-3"
                                    onChange={(e) => onFieldChange(e)}
                                    value={formData["name"]}
                                    type="text"
                                    placeholder="First and last name"
                                    required
                                />
                                <PhoneInput international defaultCountry="AU" className="form-control mb-3" countryCallingCodeEditable={false} value={formData["mobile"] || ""} placeholder="Mobile" onChange={onMobileChange} />
                                <input
                                    name="email"
                                    className="form-control mb-3"
                                    onChange={(e) => onFieldChange(e)}
                                    value={formData["email"]}
                                    type="email"
                                    placeholder="Email"
                                    required
                                />
                                <textarea
                                    rows={10}
                                    className="form-control mb-3"
                                    onChange={(e) => onFieldChange(e)}
                                    value={formData["message"]}
                                    name="message"
                                    placeholder="Message"
                                    required
                                />
                                <input
                                    type="button"
                                    className="contact-us-sen-message"
                                    disabled={loading}
                                    onClick={(e) => handleSubmit(e)}
                                    value="SEND MESSAGE"
                                />
                                <p style={{ color: "red" }}>{formError ? formErrorMessage : null}</p>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <ToastContainer pauseOnFocusLoss draggable={false} />
        </>
    );
};

export default Contact;

/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */
